import { DiscoveryApi } from '@backstage/core-plugin-api';
import { MetricName } from '../types';

export type MetricRecord = {
  owner: string;
  name: string;
  date: Date;
  deployments: number;
  leadtime?: string;
  mttr?: string;
  change_failure?: string;
  leadtime_pr?: string;
  leadtime_deployment?: string;
  pr_review_time?: string;
  time_to_first_commit?: string;
  error?: string;
};

export type MetricsResponse = {
  metrics?: MetricRecord[];
  errorMessage?: string;
};

export default class ProductivityHubBackendClient {
  private readonly discoveryApi: DiscoveryApi;

  constructor(options: { discoveryApi: DiscoveryApi }) {
    this.discoveryApi = options.discoveryApi;
  }

  public async getMetrics({
    org,
    repo,
    metric,
    since,
    until,
  }: {
    org: string;
    repo: string;
    metric: MetricName;
    since: string;
    until: string;
  }): Promise<MetricsResponse> {
    const url = `${await this.discoveryApi.getBaseUrl(
      'productivity-hub',
    )}/metrics?org=${org}&repo=${repo}&metric=${metric}&since=${since}&until=${until}`;
    const res = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const { data, error } = await res.json();
    return {
      metrics: data,
      errorMessage: data?.message || error || data?.Message,
    };
  }
}
